var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.st0 {\r\n\t\t\tfill: #FF0000;\r\n\t\t}\r\n\r\n\t\t.st1 {\r\n\t\t\tfill: #FFFFFF;\r\n\t\t}\r\n\r\n\t\t.st2 {\r\n\t\t\tenable-background: new;\r\n\t\t}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "25.3,75.8 4.5,55 4.5,25.7 25.3,4.9 54.7,4.9 75.4,25.7 75.4,55 54.7,75.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.9,6.7l19.7,19.7v27.8L53.9,74H26.1L6.3,54.3V26.4L26.1,6.7L53.9,6.7 M55.4,2.9H24.5l-22,22v30.9l22,22 h30.9l22-22V24.9L55.4,2.9L55.4,2.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.8,45.7l2.5-1.8c0.8,1.8,2,3,4.1,3c1.8,0,2.8-1,2.8-2.5s-1-2.3-2.8-2.5l-1.3-0.3c-3.8-1-4.8-3-4.8-5.1 c0-3,2.3-5.3,6.1-5.3c3,0,5.1,1.5,5.8,2.8l-2.5,1.8c-0.8-1.3-1.8-2-3.3-2s-2.5,1-2.5,2.3s1,1.8,2.8,2.3l1.5,0.3 c3.3,0.8,4.8,2.3,4.8,5.1c0,3.5-2.5,5.6-6.3,5.6C12.9,49.5,10.1,48.4,8.8,45.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.4,34c0,2,0,4.3,0,6.3c0,2.8,0,6.3,0,8.9h-3.5c0-2.5,0-6.1,0-8.9c0-2,0-4.3,0-6.3H23v-2.5h13.2V34H31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.5,40.3c0-5.1,2.5-9.1,7.8-9.1s7.8,4.1,7.8,9.1c0,5.3-2.5,9.1-7.8,9.1C40.2,49.5,37.5,45.4,37.5,40.3z  M49.4,40.3c0-3.5-1-6.6-4.1-6.6s-4.1,3-4.1,6.6c0,3.5,1.3,6.6,4.1,6.6C48.3,46.9,49.4,43.9,49.4,40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.4,36.8c0,3-2,5.3-6.6,5.3H60c0,2.3,0,5.1,0,7.1h-3.5c0-2.5,0-6.1,0-8.9s0-6.3,0-8.9h6.3 C67.3,31.5,69.4,33.8,69.4,36.8z M65.6,36.8c0-1.5-0.8-2.8-2.8-2.8H60c0,1.8,0,3.8,0,5.6h2.8C64.8,39.6,65.6,38.3,65.6,36.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopSign);
export default __webpack_public_path__ + "static/media/stop-sign.1530dbb284d5f4e7ae657b8a9bd86c7a.svg";
export { ForwardRef as ReactComponent };